// eslint-disable-next-line @typescript-eslint/no-unused-vars
import type { ClientFormInputs, ClientStatusObj, EditClientFormInputs,clientConfigType } from 'src/components/types/types';
import http from '../common/http-auth'


// eslint-disable-next-line @typescript-eslint/explicit-module-boundary-types, @typescript-eslint/explicit-function-return-type
export const getAllClientData = async (roleId?: number) => {
    const response = http.get(`/client/all${roleId !== undefined ? `?roleId=${roleId}` : ''}`);
    return response;
};

// eslint-disable-next-line @typescript-eslint/explicit-module-boundary-types, @typescript-eslint/explicit-function-return-type
export const getClientDetailsById = async (id: string) => {
    const response = http.get(`/client/${id}`)
    return response;
}

// eslint-disable-next-line @typescript-eslint/explicit-module-boundary-types, @typescript-eslint/explicit-function-return-type, @typescript-eslint/no-explicit-any
export const addClientData = async (data: any) => {
    const response = http.post(`/client/add`, data)
    return response;
}

// eslint-disable-next-line @typescript-eslint/explicit-module-boundary-types, @typescript-eslint/explicit-function-return-type
export const updateClientData = async (data: EditClientFormInputs) => {
    const response = http.put(`/client/update`, data)
    return response;
}

// eslint-disable-next-line @typescript-eslint/explicit-module-boundary-types, @typescript-eslint/explicit-function-return-type
export const changeStatusClientData = async (data: ClientStatusObj) => {
    const response = http.post(`/client/activate`, data)
    return response;
}
// eslint-disable-next-line @typescript-eslint/explicit-module-boundary-types, @typescript-eslint/explicit-function-return-type
export const getConfigurationList = async (clientId: number) => {
    const response = http.get(`/clientconfig/all?clientId=${clientId}`)
    return response;
}
// eslint-disable-next-line @typescript-eslint/explicit-module-boundary-types, @typescript-eslint/explicit-function-return-type
export const getConfigurationFields = async () => {
    const response = http.get(`/clientconfig/fields`)
    return response;
}
// eslint-disable-next-line @typescript-eslint/explicit-module-boundary-types, @typescript-eslint/explicit-function-return-type
export const saveClientConfiguration = async (data: clientConfigType) => {
    const response = http.post(`/clientconfig/add`, data)
    return response;
}
